/** Scroll every page scroller to the top and optionally move keyboard focus. */
export function focusPageTop(elementId?: string) {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  document.querySelectorAll('[data-page-scroll]').forEach((node) => {
    if (node instanceof HTMLElement) node.scrollTop = 0;
  });
  if (!elementId) return;
  document.getElementById(elementId)?.focus({ preventScroll: true });
}
